import React from "react";

/**
 * Logotipo oficial — Hacienda Nápoles (casa + wordmark, azul, fondo transparente).
 * `size` controla la altura; el ancho se ajusta para respetar la proporción original.
 */
export default function Logo({ variant = "seal", size = 48, className = "", showText = false }) {
    const h = typeof size === "number" ? `${size}px` : size;

    if (variant === "wordmark") {
        return (
            <div className={`flex items-center gap-3 ${className}`} data-testid="brand-wordmark">
                <img
                    src="/logo-oficial.png"
                    alt="Hacienda Nápoles"
                    style={{ height: h, width: "auto" }}
                    className="object-contain shrink-0"
                />
                {showText && (
                    <span className="font-display text-2xl leading-none">Hacienda Nápoles</span>
                )}
            </div>
        );
    }

    if (variant === "seal-light") {
        // Sobre fondos oscuros: versión beige del logotipo, sin placa (se funde con el azul del fondo).
        return (
            <div className={`inline-block ${className}`} data-testid="brand-logo-light">
                <img
                    src="/logo-beige.png"
                    alt="Hacienda Nápoles"
                    style={{ height: h, width: "auto" }}
                    className="object-contain"
                />
            </div>
        );
    }

    return (
        <img
            src="/logo-oficial.png"
            alt="Hacienda Nápoles"
            style={{ height: h, width: "auto" }}
            className={`object-contain ${className}`}
            data-testid="brand-logo"
        />
    );
}
